export default __webpack_public_path__ + "static/Farcher-4cc77ef270dd34a9d3fd1c15afef23bb.jpg";